import { cn } from '@workspace/ui/lib/utils'

interface ConfidenceBarProps {
  value: number
  color: string
  className?: string
  /** Width of the track. Defaults to flex-1 (fills available space). */
  trackClassName?: string
}

export { ConfidenceBar as EvaluationConfidenceBar }

export function ConfidenceBar({
  value,
  color,
  className,
  trackClassName = 'flex-1',
}: ConfidenceBarProps) {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <span className="text-[9px] text-muted-foreground/80">Confidence</span>
      <div className={cn('relative h-1 rounded-full bg-input', trackClassName)}>
        <div
          className="h-1 rounded-full"
          style={{ width: `${value}%`, backgroundColor: `${color}80` }}
        />
      </div>
      <span className="text-[9px] font-semibold tabular-nums" style={{ color }}>
        {value}%
      </span>
    </div>
  )
}
